import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadMaisEguListFailed, loadMaisEguListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';

export default function* loadMaisEguList(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL}/resources/mais-egu-types`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadMaisEguListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadMaisEguListFailed());
      yield call(rejectActionPromise(action, data));
    }
    /*
    yield put(loadMaisEguListSuccessful({
      data: [
        {
          id: 1227.1,
          procedure_label: 'Предоставление разрешения',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.2,
          procedure_label: 'Аннулирование действия разрешения',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.3,
          procedure_label: 'Внесение изменений в реестр перевозчиков на основании заявления',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.4,
          procedure_label: 'Получение выписки из реестра перевозчиков',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.5,
          procedure_label: 'Внесение изменений в реестр перевозчиков на основании уведомления',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.6,
          procedure_label: 'Внесение сведений в реестр ЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.7,
          procedure_label: 'Исключение сведений из реестра ЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.8,
          procedure_label: 'Внесение изменений в реестр ЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1227.9,
          procedure_label: 'Получение выписки из реестра ЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1228.1,
          procedure_label: 'Предоставление права на осуществление деятельности СЗЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1228.2,
          procedure_label: 'Аннулирование действия разрешения на осуществление деятельности СЗЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1228.3,
          procedure_label: 'Внесение изменений в реестр СЗЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
        {
          id: 1228.4,
          procedure_label: 'Получение выписки из реестра СЗЛТ',
          created_at: '2025-01-20 09:00:00',
          response_date: '',
          registry: 'СЗЛТ',
          number: '00000000111',
          source: 'Пользователь',
          status: 2,
          content: 'Изменился адрес электронной почты с 6407788@mail.ru на taksimirazh@mail.ru',
        },
      ],
      meta: {
        limit: 20,
        page: 1,
        total: 5,
      },
    }));
    */
  } catch (e) {
    // yield put(loadMaisEguListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
